module.exports = __webpack_public_path__ + "media/images/sp/top/kodawari_dress@3x-5502179bdc22880e5f2efbb56c7bcac9.webp";